// Calls to the master project's server functions (functions/index.js).
// Only admins can use these; the function itself checks /admins.

import { getFunctions, httpsCallable } from 'firebase/functions';
import { masterApp } from '../firebase/master';

const fns = getFunctions(masterApp, 'europe-west1');

/** Remove a user's authenticator app (lost / new phone). Returns how many
 *  second steps were removed (0 if two step sign in was already off). */
export async function resetTwoStep(uid: string): Promise<number> {
  const res = await httpsCallable<{ uid: string }, { removed: number }>(fns, 'resetTwoStep')({ uid });
  return res.data.removed;
}

/** Plain English for a failed call. */
export function functionErrorText(err: unknown): string {
  const code = (err as { code?: string })?.code ?? '';
  if (code === 'functions/not-found' || code === 'functions/internal')
    return 'The reset service is not set up yet. Deploy the server functions first.';
  if (code === 'functions/permission-denied') return 'Only DiaWolt admins can do this.';
  if (code === 'functions/unauthenticated')   return 'Please sign in again.';
  return err instanceof Error && err.message ? err.message : 'Something went wrong. Please try again.';
}
